import { Entity, LiveData } from '@toeverything/infra';

import type { DevtoStore } from '../store/devto';
import type { DevtoConfig } from '../type';

export class DevtoIntegration extends Entity {
  constructor(private readonly devtoStore: DevtoStore) {
    super();
  }

  settings$ = LiveData.from(this.devtoStore.watchSetting(), undefined);

  setting$<T extends keyof DevtoConfig>(
    key: T
  ): LiveData<DevtoConfig[T] | undefined> {
    return this.settings$.selector(setting => setting?.[key]);
  }

  updateSetting<T extends keyof DevtoConfig>(
    key: T,
    value: DevtoConfig[T]
  ) {
    this.devtoStore.setSetting(key, value);
  }

  getApiKey(): string | undefined {
    return this.devtoStore.getSetting('apiKey');
  }

  connect(apiKey: string) {
    this.devtoStore.setSettings({
      apiKey,
    });
  }

  disconnect() {
    this.devtoStore.clearSettings();
  }

  isConnected(): boolean {
    return !!this.devtoStore.getSetting('apiKey');
  }
}
